var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7277 32.0001C20.4101 28.9844 21.606 25.7149 22.27 22.3156H30.7403C29.6977 24.8218 28.0513 27.0221 25.9524 28.7143C23.8534 30.4064 21.3691 31.5363 18.7277 32.0001Z",
    fill: "#F2EED5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3456 30.613C14.5063 30.9163 14.745 31.1698 15.0363 31.3464C15.3276 31.5231 15.6606 31.6164 15.9999 31.6164C16.3393 31.6164 16.6722 31.5231 16.9635 31.3464C17.2548 31.1698 17.4935 30.9163 17.6543 30.613C19.0355 28.0067 20.04 25.2123 20.6369 22.3156H11.3629C11.9599 25.2123 12.9644 28.0067 14.3456 30.613Z",
    fill: "#F2EED5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2725 32.0001C10.6311 31.5363 8.14687 30.4064 6.0479 28.7143C3.94894 27.0221 2.30256 24.8218 1.25995 22.3156H9.73022C10.3943 25.7149 11.5902 28.9844 13.2725 32.0001Z",
    fill: "#F2EED5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5452 11.3081C22.9928 14.4194 22.9928 17.5803 22.5452 20.6916H31.3175C32.2275 17.6319 32.2275 14.3678 31.3175 11.3081H22.5452Z",
    fill: "#F2EED5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9273 20.6916C21.3987 17.5821 21.3987 14.4176 20.9273 11.3081H11.0728C10.6013 14.4176 10.6013 17.5821 11.0728 20.6916H20.9273Z",
    fill: "#F2EED5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45481 20.6916C9.0072 17.5803 9.0072 14.4194 9.45481 11.3081H0.682448C-0.227483 14.3678 -0.227483 17.6319 0.682448 20.6916H9.45481Z",
    fill: "#F2EED5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7277 0C20.4101 3.01568 21.606 6.28522 22.27 9.68451H30.7403C29.6977 7.17825 28.0513 4.97797 25.9524 3.2858C23.8534 1.59363 21.3691 0.463777 18.7277 0Z",
    fill: "#F2EED5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3456 1.38706C12.9644 3.99341 11.9599 6.7879 11.3629 9.68461H20.6369C20.04 6.78791 19.0355 3.9934 17.6543 1.38706C17.4935 1.08378 17.2548 0.830396 16.9635 0.65374C16.6723 0.477084 16.3393 0.383792 15.9999 0.383789C15.6606 0.383786 15.3276 0.477089 15.0363 0.65374C14.745 0.830391 14.5063 1.08378 14.3456 1.38706Z",
    fill: "#F2EED5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25995 9.68451H9.73022C10.3943 6.28522 11.5902 3.01568 13.2725 0C10.6311 0.463776 8.14687 1.59363 6.04791 3.2858C3.94895 4.97797 2.30256 7.17825 1.25995 9.68451Z",
    fill: "#F2EED5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.1ef6f38fe6319bfda5b9990e29057004.svg";
export { ForwardRef as ReactComponent };